import script from "./cancel.vue?vue&type=script&setup=true&lang=js"
export * from "./cancel.vue?vue&type=script&setup=true&lang=js"

import "./cancel.vue?vue&type=style&index=0&id=2f722335&lang=scss"

const __exports__ = script;

export default __exports__